import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Block } from '@app/core/models/block/block.model';
import { ScryptZMailerLite } from './scriptLoader.service';

declare global {
  interface Window {
    ml?: (...args: any[]) => void;
    __ml?: any;
    __ml__initialized?: boolean;
  }
}

@Component({
  selector: 'app-scrypt',
  templateUrl: './scrypt.component.html',
})
export class ScryptComponent implements OnInit, AfterViewInit {
  @Input() item: Block;

  @ViewChild('myDiv', {static: false}) myDiv!: ElementRef;

  @ViewChild('myDiv2', {static: false}) myDiv2!: ElementRef;

  // iframeScriptContent: SafeHtml = '';
  iframeContent: SafeHtml = '';
  divAttributes: { class: string; dataForm: string } = {
    class: '',
    dataForm: '',
  };
  onOff = false;

  constructor(
    private renderer: Renderer2,
    public scryptLite: ScryptZMailerLite,
  ) {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.controllerHTML();
    }, 500);
  }

  ngOnInit(): void {
    this.removeMailerLiteScript();
    document.querySelectorAll('script[src*="mailerlite"]');

    this.scryptLite.itemMap[this.item.uId] = this.item;
    // this.scryptLite.item = this.item;
    this.divAttributes = this.scryptLite.extractDivAttributes(this.item);
  }

  removeMailerLiteScript() {
    const script = document.querySelector('script[src*="mailerlite"]');
    if (script) {
      script.remove();
    }
    delete window.ml;
    delete window.__ml;
    delete window.__ml__initialized;
  }

  controllerHTML() {
    // const dataNewForm = this.myDiv2.nativeElement.dataset.form;
    // const scriptData = this.scryptLite.scryptHTML[dataNewForm];
    // if (
    //   Object.keys(this.scryptLite.scryptHTML).length > 0 &&
    //   this.scryptLite.scryptHTML[dataNewForm]
    // ) {
    //   this.onOff = true;
    //   // if (scriptData && scriptData?.body) {
    //   //   this.renderer.appendChild(this.myDiv2.nativeElement, scriptData.body);
    //   // }
    // } else {
    this.scryptLite.setIframeScriptContentHtml(this.item);
    const targetNode = this.myDiv.nativeElement;

    const observer = new MutationObserver((_, o) => {
      if (this.myDiv.nativeElement.children.length) {
        const clone = this.myDiv.nativeElement.cloneNode(true) as HTMLElement;
        const dataForm = clone.dataset.form;
        clone.hidden = false;

        this.scryptLite.scryptHTML[dataForm] = {
          key: dataForm,
          body: clone,
        };

        this.onOff = false;
        o.disconnect();
      }
    });

    observer.observe(targetNode, {childList: true, subtree: true});
  }

  // }
}
